import { cn } from "@u/cn";
import { FIELD_LABEL_CLASS } from "@ui/form";
import InfoTooltip from "@ui/info-tooltip";

type FieldLabelProps = React.ComponentProps<"label"> & {
  /** Convenience: label text + optional ℹ tooltip, laid out inline. Replaces the
   *  per-file `function FieldLabel({label, tip})` shadows. Ignored if children set. */
  label?: string;
  tip?: string;
};

/**
 * Canonical form field label (mono uppercase). Two APIs: pass `children`, or the
 * `label` (+ optional `tip`) convenience props for a text label with an ℹ tooltip.
 */
export function FieldLabel({
  className,
  label,
  tip,
  children,
  ...props
}: FieldLabelProps) {
  const hasLabel = label !== undefined;
  return (
    // Passthrough wrapper: callers supply htmlFor (or nest the control) via props.
    <label
      className={cn(
        FIELD_LABEL_CLASS,
        hasLabel && "flex items-center gap-1.5",
        className,
      )}
      {...props}
    >
      {hasLabel ? (
        <>
          {label}
          {tip && <InfoTooltip text={tip} />}
        </>
      ) : (
        children
      )}
    </label>
  );
}
